<app-shipment-system-simplenav></app-shipment-system-simplenav>
<nav class="navbar navbar-expand-lg p-0 border border-bottom mb-3">
    <div class="container">
        <div class="collapse navbar-collapse">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item"><a class="nav-link" [routerLink]="'/kontrol/picking-list'">Opret plukliste</a></li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="'/kontrol/picking-lists'">Pluklister</a>
                </li>
            </ul>
        </div>
    </div>
</nav>
